import config from 'config';
import { http_client } from './api';

const getList = async (page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'code?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'code', data).then((response) => {
    return response.data;
  });
};
const read = async (id) => {
  return http_client.get(config.apiUrl + 'code/' + id).then((response) => {
    return response.data;
  });
};
const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'code/' + id, data).then((response) => {
    return response.data;
  });
};
const del = async (id) => {
  return http_client.delete(config.apiUrl + 'code/' + id).then((response) => {
    return response.data;
  });
};

const AccessCodeService = {
  getList,
  create,
  read,
  update,
  del
};

export default AccessCodeService;
